<div >
    <aside id="sidebar" class="bg-dark text-white">
        <div class="d-flex flex-column justify-content-end">
           
            <div class="pt-3 text-center fs-4">
                <p class="fw-bold">Presby Global Connect </p>
            </div>
            <div class="text-center">
              <img src="assets/logo.png" width="50" height="50" alt="">
            </div>
        </div>
        <hr>
        <ul class="sidebar-nav">
            <li class="sidebar-item"  >
                <a [routerLinkActive]="['active']"[routerLink]="['admin']" class="sidebar-link a">
                  <fa-icon [icon]="['fas', 'home']"></fa-icon>
                  <span>Home</span>
                </a>
            </li>
            <li class="sidebar-item"  >
              <a [routerLinkActive]="['active']" [routerLink]="['church-list']" class="sidebar-link a">
                <fa-icon [icon]="['fas', 'home']"></fa-icon>
                <span>Churches</span>
              </a>
          </li>
            <li class="sidebar-item"  >
              <a [routerLinkActive]="['active']"[routerLink]="['settings']" class="sidebar-link a">
                <fa-icon [icon]="['fas', 'gear']"></fa-icon>
                <span>Settings</span>
              </a>
          </li>
       
        </ul>
        <div class="sidebar-footer d-flex justify-content-center p-4">
           
            <button type="button" class="btn btn-light  " (click)="logOut()" >
              <div  class="sidebar-link">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 512 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M217.9 105.9L340.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L217.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1L32 320c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM352 416l64 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0c53 0 96 43 96 96l0 256c0 53-43 96-96 96l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32z"/></svg>
                  <span  >Logout</span>
              </div>
            </button>
        </div>
    </aside>
</div>



